import styled from 'styled-components';
import { XIColors, XIShadowsDown } from '@inmoment/the-kitchen';

export const ColorSwatchWrapper = styled.div`
  min-width: 300px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid ${XIColors.grey.light[80]};
`;
interface ColorOverlayType {
  color: string;
}
export const ColorOverlay = styled.div`
  background: ${(props: ColorOverlayType) => props.color};
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  height: 48px;
  width: 100%;
  align-items: center;
  justify-content: space-evenly;
  box-shadow: ${XIShadowsDown[0]};
  transition: all 0.1s;
  cursor: pointer;
  position: relative;
  &:hover {
    z-index: 111;
    transform: scaleX(1.05) scaleY(1.1);
    border-radius: 6px;
    box-shadow: ${XIShadowsDown[3]};
  }
`;
export const ColorRowWrapper = styled.div`
  text-shadow: 2px 2px white;
  display: flex;
  height: 48px;
  width: 100%;
  align-items: center;
  justify-content: space-evenly;
  box-shadow: ${XIShadowsDown[0]};
  transition: all 0.1s;
  cursor: pointer;
  position: relative;
  ${ColorOverlay}:hover {
    transform: scaleX(1.05) scaleY(1.1);
    border-radius: 6px;
    box-shadow: ${XIShadowsDown[3]};
  }
`;
interface ColorPrimaryWrapperType {
  color: string;
}
export const ColorPrimaryWrapper = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 6px;
  box-sizing: border-box;
  background: ${(props: ColorPrimaryWrapperType) => props.color};
`;

export const CustomHoverText = styled.div`
  cursor: pointer;
  transition: opacity 0.075s;
  opacity: 0.6;
  height: 100%;
  display: flex;
  align-items: center;
  /* justify-content: center; */
  &:hover {
    opacity: 1;
  }
  &:active {
    opacity: 0.8;
  }
`;
